import { primary } from './colors';

export const transitionTime = {
  short: '0.2s',
  long: '0.4s',
};

export const textFieldFadeIn = {
  transitionProperty: 'border-color',
  transitionDuration: transitionTime.short,
};

export const textFieldFadeOut = {
  transitionProperty: 'border-color',
  transitionDuration: transitionTime.long,
};

export const textFieldHoverStyle = {
  ...textFieldFadeIn,
  borderColor: primary,
};

export const textFieldFocusStyle = textFieldHoverStyle;
